"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useCianHost = require("./useCianHost");
Object.keys(_useCianHost).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useCianHost[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useCianHost[key];
    }
  });
});